import React from 'react';
import { Fragment, useState, useEffect } from 'react';
import { Row, Alert } from 'react-bootstrap';
import FormBusca from './form_busca';
import AtosService from '../../../services/ato'
import Ato from './ato';

const ListarAtos = () => {


    const [atos, setAtos] = useState([]);
    const [vazio, setVazio] = useState(false);

    async function fetchAtosIn() {
        const response = await AtosService.listar();
        if (response.data.length >= 1) {
            setAtos(response.data)
            setVazio(false)
        } else {
            setAtos([])
            setVazio(true)
        }
    }

    useEffect(() => {
        fetchAtosIn();
    }, []);


    return (
        <Fragment>
            <Fragment>
                <FormBusca
                    setAtos={setAtos}
                    setVazio={setVazio}
                    fetchAtosIn={fetchAtosIn}
                    atos={atos}
                />
            </Fragment>

            {vazio ? <Fragment>
                <Alert variant='danger'>Sua busca não gerou nenhum resultado :(</Alert>
            </Fragment> :
                <Fragment>
                    <Row xs={1}>
                        {atos.map((ato, index) =>
                            <Ato
                                ato={ato}
                                key={index}
                            />
                        )}
                    </Row>
                </Fragment>}
        </Fragment>

    )
}

export default ListarAtos;